import React from 'react'
import {Navbar, Nav, Container, NavDropdown} from "react-bootstrap";
import useFetch from "../hooks/useFetch";


export default function Navigation() {
    const { data: archives, loading: loadingArchives, error: errorArchives } = useFetch('https://steadfast-festival-dd089030c4.strapiapp.com/api/archivs?sort[0]=Title:asc&populate=*', {
        headers: {
            'Authorization': `Bearer ${process.env.REACT_APP_API_KEY}`,
            'Content-Type': 'application/json'
        }

    })
    const { data: galleries, loading: loadingGalleries, error: errorGalleries } = useFetch('https://steadfast-festival-dd089030c4.strapiapp.com/api/galleries?sort[0]=Title:asc&populate=*', {
        headers: {
            'Authorization': `Bearer ${process.env.REACT_APP_API_KEY}`,
            'Content-Type': 'application/json'
        }

    })

    console.log(galleries)

    if (loadingArchives || loadingGalleries) return <p>loading...</p>
    if (errorArchives || errorGalleries) return <p>Error :(</p>

    return (
        <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
            <Container>
                <Navbar.Brand href="/">Räbe Jass</Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse id="responsive-navbar-nav">
                    <Nav className="me-auto">
                        <Nav.Link href="/">Aktuell</Nav.Link>
                        <Nav.Link href="/anmeldung">Anmeldung</Nav.Link>
                        <Nav.Link href="/räbejass">Räbejass 2025</Nav.Link>
                        <Nav.Link href="/gewinner">Sieger</Nav.Link>
                        <Nav.Link href="/organisatoren">Organisatoren</Nav.Link>
                        <NavDropdown title="Galerie" id="basic-nav-dropdown">
                            {galleries.data.map(archivnavitem => (
                                <NavDropdown.Item href={`/galerie/${archivnavitem.Title}`}>{archivnavitem.Title}</NavDropdown.Item>
                            ))}
                        </NavDropdown>

                        <NavDropdown title="Archiv" id="basic-nav-dropdown">
                            {archives.data.map(archivnavitem => (
                            <NavDropdown.Item href={`/archiv/${archivnavitem.Title}`}>{archivnavitem.Title}</NavDropdown.Item>
                            ))}
                        </NavDropdown>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )

}